import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ScareLogo } from "../components/Brand";
import { MailCheck } from "lucide-react";

export default function ForgotPasswordPage() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(null); // { reset_url? }
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { const r = await forgotPassword(email); setDone(r || {}); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md st-card p-10 st-fade-up" data-testid="forgot-page">
        <div className="flex justify-center mb-6"><ScareLogo size={36} /></div>
        {done ? (
          <div className="text-center" data-testid="forgot-sent">
            <div className="inline-flex w-16 h-16 rounded-full bg-[#160a0a] items-center justify-center text-[#dc2626] mb-5"><MailCheck size={30} /></div>
            <h1 className="text-2xl font-bold mb-2">Check your email</h1>
            <p className="text-[#bbb]">If an account exists for <span className="text-white">{email}</span>, we've sent a password reset link.</p>
            {done.reset_url && (
              <div className="mt-5 text-left bg-[#0e0e0e] border border-[#1a1a1a] rounded-lg p-3">
                <div className="text-[10px] uppercase tracking-wider text-[#7a7a7a] mb-1">Dev mode — email is mocked</div>
                <Link to={done.reset_url.replace(window.location.origin, "")} className="st-link text-sm break-all" data-testid="forgot-reset-link">Reset your password now →</Link>
              </div>
            )}
            <p className="text-sm text-[#8a8a8a] mt-6"><Link to="/login" className="st-link">Back to sign in</Link></p>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-1">Forgot your password?</h1>
            <p className="text-[#8a8a8a] mb-6">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <input data-testid="forgot-email" className="st-input" type="email" required placeholder="you@scaretickets.co.uk"
                     value={email} onChange={(e) => setEmail(e.target.value)} />
              <button data-testid="forgot-submit" disabled={loading} className="st-btn w-full justify-center">
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <p className="text-center text-sm text-[#8a8a8a] mt-6"><Link to="/login" className="st-link">Back to sign in</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
